import React, { useEffect, useState, useContext } from "react";
import { Outlet, useNavigate } from "react-router";
import Sidebar from "../molecules/Sidebar";
import Header from "../atoms/Header";
import { FaSpinner } from "react-icons/fa";
import Modal from "../atoms/Modal";
import MobileBlocked from "../atoms/MobileBlocked";
import { isMobileOS } from "../../utils/mobileDetection";
import { AuthContext } from "./AuthContext";

const MainLayout: React.FC = () => {
  const { user, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  const [cookiesEnabled, setCookiesEnabled] = useState(true);

  useEffect(() => {
    function areCookiesEnabled() {
      try {
        document.cookie = "cookietest=1";
        const enabled = document.cookie.indexOf("cookietest=") !== -1;
        document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
        return enabled;
      } catch (e) {
        return false;
      }
    }
    setCookiesEnabled(areCookiesEnabled());
  }, []);

  // Redirect to signin if user is not authenticated
  useEffect(() => {
    if (!loading && !user) {
      navigate("/signin");
    }
  }, [loading, user, navigate]);

  const mainLayoutStyles: React.CSSProperties = {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    backgroundColor: "#efefef",
  };

  const mainContentStyles: React.CSSProperties = {
    flex: 1,
    marginLeft: 0,
    marginTop: "1rem",
    overflowY: "auto",
    padding: "0 1rem",
    scrollbarWidth: "thin",
    scrollbarColor: "#581c87 #f0f0f0",
  };

  const customScrollbar = `
    ::-webkit-scrollbar {
      width: 10px;
    }
    ::-webkit-scrollbar-track {
      background: #f0f0f0;
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
      background: #007bff;
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #0056b3;
    }
  `;

  if (!cookiesEnabled) {
    return (
      <Modal isOpen={true} onClose={() => {}}>
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              marginBottom: "1rem",
            }}
          >
            Cookies Required
          </h2>
          <p style={{ marginBottom: "1.5rem" }}>
            This site requires cookies to be enabled for authentication and
            proper functionality.
            <br />
            Please enable cookies in your browser settings and refresh the page.
          </p>
          <p style={{ color: "#b91c1c", fontWeight: "bold" }}>
            You cannot use this site without enabling cookies.
          </p>
        </div>
      </Modal>
    );
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#efefef]">
        <div className="text-center text-gray-500">
          <div className="flex flex-col items-center">
            <FaSpinner size={40} className="text-blue-500 mb-4 animate-spin" />
          </div>
        </div>
      </div>
    );
  }

  // Check mobile access after user is loaded
  // Allow access if user has areCool === true, block everyone else
  if (user && isMobileOS() && !user.areCool) {
    return <MobileBlocked />;
  }

  return (
    <div style={mainLayoutStyles}>
      <style>{customScrollbar}</style>

      {user && <Sidebar role={user.role} />}

      <main style={mainContentStyles}>
        <Header />
        <div className="flex flex-col w-full p-2 pb-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
